import { useState } from "react";
import moment from "moment";

import showMoreIcon from "assets/images/show-more-icon.svg";
import { Pill } from "components/ui/Pill";
import { formatCdmStatus, getCdmStatusColors } from "utils/cdmStatus";

import { getReviewTypeTitle } from "../../constants/reviewTypes";
import style from "./CdmSidebar.module.css";

// Items come straight from cdmStatus.reviewHistory; mirror ReviewsHistoryTable's
// precedence (status ?? clinicalMessageStatus) so a failed HL7 message is flagged.
const getItemStatus = (item) => item.status ?? item.clinicalMessageStatus;

export const Item = ({ items, name, activeItemId, setActiveItemId, onAddItemButtonClick }) => {
  const [isExpanded, setIsExpanded] = useState(true);

  if (items.length < 1) {
    return null;
  }

  return (
    <div
      className={`${style.cdmSidebarItem} ${
        !isExpanded
          ? style.cdmSidebarItemNotExpanded
          : style.cdmSidebarItemExpanded
      }`}
    >
      <div className={style.cdmSidebarItemHeaderWrapper}>
        <div className={style.cdmSidebarItemHeaderInnerWrapper}>
          <div className={style.cdmSidebarItemHeaderTitleWrapper}>
            <h3>{name}</h3>
          </div>
          <button
            aria-label="show more"
            onClick={() => setIsExpanded((prev) => !prev)}
          >
            <img src={showMoreIcon} alt="showmore" />
          </button>
        </div>
      </div>
      {isExpanded && (
        <div className={style.cdmSidebarItemButtonWrapper}>
          {items.map((item) => {
            const status = getItemStatus(item);
            const statusColors = getCdmStatusColors(status);

            return (
              <button
                key={item.id}
                className={`${style.cdmSidebarItemButton} ${
                  activeItemId === item.id
                    ? style.cdmSidebarItemButtonActive
                    : ""
                }`}
                onClick={() => setActiveItemId(item.id)}
              >
                <span>
                  {moment(item.reviewDate || item.date).format("DD.MM.YYYY")}
                </span>
                {!!item.reviewType && (
                  <span className={style.reviewTypeChip}>
                    {getReviewTypeTitle(item.reviewType)}
                  </span>
                )}
                {!!status && (
                  <Pill
                    color={statusColors.color}
                    bg={statusColors.bg}
                    border={statusColors.border}
                  >
                    {formatCdmStatus(status)}
                  </Pill>
                )}
              </button>
            );
          })}
          {onAddItemButtonClick && (
            <button
              type="button"
              className={style.addItemButton}
              onClick={onAddItemButtonClick}
            >
              Add new review
            </button>
          )}
        </div>
      )}
    </div>
  );
};
